export default {
  heading: "忘 記 密 碼",
  typeHint: "請選擇輸入電郵地址<font color='#FF0000'>或</font>登入名稱：",
  emailRadioLabel: "登入電郵<font color='#FF0000'>或</font>聯絡電郵",
  cityIdRadioLabel: "登入名稱",
  emailLabel: "登入電郵或聯絡電郵",
  cityIdLabel: "登入名稱",
  submitBtn: "確定",
  resetBtn: "重設",
  closeBtn: "關閉",
  emailIsEmpty: "請輸入您的電郵地址。",
  cityIdIsEmpty: "請輸入您的登入名稱。",
  emailFormatWrong: "電郵地址格式不正確，請重新輸入。",
  recaptcha_lang: "zh-HK",
  emailNotFound: "找不到此電郵地址。請檢查您所輸入的電郵地址是否正確。",
  cityIdNotFound: "找不到此教城帳戶。請檢查您所輸入的帳戶是否正確。",
  accountNoEmail: "系統找不到您的登記電郵或聯絡電郵的記錄，請聯絡您的學校管理員重設密碼。",
  completed:
    "我們已將設定新密碼的連結寄到以下的電郵地址：",
};
